import React from 'react'
import cn from 'classnames'

import styles from './styles.module.scss'

interface ColorBoxProps {
	type?: 'blue' | 'lightBlue' | 'green'
}

export const Box: React.FC<React.PropsWithChildren<ColorBoxProps>> = ({ type, children }) => {
	return (
		<div
			className={cn(styles.box, {
				[styles.blueBox]: type === 'blue',
				[styles.lightBlueBox]: type === 'lightBlue',
				[styles.greenBox]: type === 'green',
			})}
		>
			{children}
		</div>
	)
}
